var React = require('react');

function Heart24x24 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=24x24, Invert=off"},React.createElement("path",{"id":"Vector","d":"M20.56 4.212a5.884 5.884 0 011.682 1.916 6.162 6.162 0 01.395 5.042 5.983 5.983 0 01-1.362 2.172l-7.889 7.989c-.204.212-.447.38-.714.495a2.132 2.132 0 01-1.685 0 2.197 2.197 0 01-.714-.495l-7.504-7.99a6.223 6.223 0 01-1.74-3.767 6.304 6.304 0 01.992-4.05A5.825 5.825 0 013.87 3.782a5.554 5.554 0 014.86-.403c.79.307 1.504.79 2.093 1.415l1.2 1.255 1.1-1.06a5.823 5.823 0 013.585-1.764 5.744 5.744 0 013.852.987v0z","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10"})));
}

Heart24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Heart24x24;

Heart24x24.default = Heart24x24;
